// extracted by mini-css-extract-plugin
export default {"badge":"badge--O9Zu9","filled":"filled--ys6hI","label":"label--ZEU69","icon":"icon--RR4fQ","compact":"compact--bXtQ2","ghost":"ghost--cxQpq"};